import { createContext, useContext, useEffect, useState } from "react";
import { getTenantIdAuth0, isAdminAuth0 } from "../authUtils";
import getTenantIdFromURL from "../utils/getTenantIdFromURL";

const prospectsARContext = createContext(undefined);

export const ProspectsARProvider= ({ children }) => {
  const [isProspects, setProspectValue] = useState(false); 
  const [tenantId, setTenantId] = useState(null); 

  useEffect(() => {
    const fetchTenantId = async () => {
      try {
        console.log('🚀 ProspectsAR fetching tenant ID...');
        const isAdmin = await isAdminAuth0();
        const selectedTenant = getTenantIdFromURL();
        const tenantIdValue = isAdmin ? selectedTenant : await getTenantIdAuth0();
        setTenantId(tenantIdValue);
        const savedValue = localStorage.getItem(`prospectValue_${tenantIdValue}`);
        setProspectValue(savedValue !== null ? JSON.parse(savedValue) : false);
      } catch (error) {
        console.error('Error in ProspectsAR fetchTenantId:', error);
      }
    };
    
    fetchTenantId();
  }, []);

  const setProspects=(val)=>{
    setProspectValue(val)
    localStorage.setItem(`prospectValue_${tenantId}`, JSON.stringify(val)); // Store prospect value using tenantId
  }
  return (
    <prospectsARContext.Provider value={{ isProspects, setProspects }}>
      {children}
    </prospectsARContext.Provider>
  );
};

export const useProspectsAR = () => {
  const context = useContext(prospectsARContext);
  if (context === undefined) {
    throw new Error('useProspectsAR must be used within a ProspectsARProvider');
  }
  return context;
};